"use client";

import { useSyncExternalStore } from "react";
import { useState } from "react";
import { Button } from "@/components/ui/Button";
import { grantAnalyticsConsent, revokeAnalyticsConsent } from "@/lib/analytics";
import {
  getStoredConsent,
  saveConsentRecord,
  type ConsentStatus,
} from "@/lib/consent";

function saveConsent(status: ConsentStatus) {
  saveConsentRecord(status);

  // 동의 시 즉시 캡처 시작(리로드 불필요), 거부 시 캡처 중단 + 저장된 데이터 삭제.
  if (status === "accepted") {
    grantAnalyticsConsent();
  } else {
    revokeAnalyticsConsent();
  }
}

// useSyncExternalStore: SSR/하이드레이션은 server snapshot(false)을 쓰고,
// 마운트 직후 client snapshot으로 전환되며 react가 알아서 re-render한다.
// useEffect+setState 패턴(react-hooks/set-state-in-effect 룰 위반)을 피하면서
// hydration mismatch도 안 남기는 표준 React 19 패턴.
const subscribe = () => () => {};

export function CookieBanner() {
  const initialVisible = useSyncExternalStore(
    subscribe,
    () => !getStoredConsent(),
    () => false,
  );
  const [dismissed, setDismissed] = useState(false);
  const visible = initialVisible && !dismissed;
  const setVisible = (next: boolean) => setDismissed(!next);

  function accept() {
    saveConsent("accepted");
    setVisible(false);
  }

  function decline() {
    saveConsent("declined");
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div
      role="region"
      aria-label="쿠키 동의"
      className="fixed bottom-0 left-0 right-0 z-50 p-4"
      style={{
        backgroundColor: "rgba(0,0,0,0.85)",
        backdropFilter: "blur(4px)",
      }}
    >
      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <p className="text-sm text-white flex-1" style={{ lineHeight: 1.6 }}>
          현들팜은 서비스 개선을 위해 방문 통계를 분석합니다. 동의하지 않으셔도
          이용에 지장은 없습니다.&nbsp;
          <a
            href="/privacy"
            className="underline"
            style={{ color: "var(--color-gold-light)" }}
          >
            개인정보처리방침
          </a>
        </p>
        <div className="flex gap-2 shrink-0">
          <Button
            variant="outline"
            size="sm"
            onClick={decline}
            className="text-white border-white/30 hover:bg-white/10 hover:text-white hover:border-white/50"
            style={{ backgroundColor: "transparent" }}
          >
            거부
          </Button>
          <Button variant="primary" size="sm" onClick={accept}>
            동의
          </Button>
        </div>
      </div>
    </div>
  );
}
